import React from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route
} from 'react-router-dom';
import Signin from './signin';
import Dashboard from './dashboard';
import Companies from './companies';

function App() {
  return (
    <Router>
      <Switch>
        <Route exact={true} path='/' component={Signin} />
        <Route exact={true} path='/dashboard' component={Dashboard} />
        <Route exact={true} path='/companies' component={Companies} />
      </Switch>
    </Router>
  );
}

export default App;
